export var RecruitProposalStatus;
(function (RecruitProposalStatus) {
    /**
     * 대기중
     */
    RecruitProposalStatus["PENDING"] = "pending";
    /**
     * 수락
     */
    RecruitProposalStatus["ACCEPTED"] = "accepted";
    /**
     * 거절
     */
    RecruitProposalStatus["REJECTED"] = "rejected";
})(RecruitProposalStatus || (RecruitProposalStatus = {}));
